import React from "react";
import theme from "../../../styles/theme";

const LoaderButton = ({ label, onClick, disabled = false, size = "md" }) => {
  const padding = size === "sm" ? `${theme.spacing.xs}px ${theme.spacing.md}px` : `${theme.spacing.sm}px ${theme.spacing.lg}px`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding,
        borderRadius: theme.borders.radius.sm,
        border: `1px solid ${theme.colors.borders.default}`,
        backgroundColor: disabled ? theme.buttons.disabled.background : theme.colors.background.input,
        color: theme.colors.text.default,
        fontFamily: theme.fonts.primary,
        fontSize: theme.fontSizes.md,
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "all 0.2s",
      }}
    >
      <span>{label}</span>
      <span style={{ transform: "rotate(0deg)", marginLeft: theme.spacing.sm }}>▼</span>
    </button>
  );
};

export default LoaderButton;
